import { connect } from "@permaweb/aoconnect"

const arIoCu = connect({
  CU_URL: "https://cu.ao-testnet.xyz",
})

export async function getPrimaryName(address: string): Promise<string> {
  const result = await arIoCu.dryrun({
    process: "agYcCFJtrMG6cqMuZfskIkFTGvUPddICmtQSBIoPdiA",
    tags: [
      { name: "Action", value: "Primary-Name" },
      { name: "Address", value: address },
    ],
  })

  if (result.Messages.length === 0) throw new Error("No response from Primary-Name")

  const message = result.Messages[0]
  const name = message.Tags.find((x: any) => x.name === "Name")?.value

  return name
}
